<div class="flow-ab">
  <mat-card appearance="outlined" class="flow flow-a">
    <mat-card-content>
      <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between" fxLayoutGap="15px">
        <div fxFlex fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" fxLayoutGap.xs="8px"
          fxLayoutAlign="space-between">
          <div fxFlex="39%" fxFlex.md="45%" fxFlex.lt-md="auto" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
            <div class="ab-container" fxFlex="85px" fxFlex.lt-md="75px">
              <div class="distribution" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="6px">
                <div class="graph">
                  <svg viewBox="0 0 36 36" class="circular-chart">
                    <path class="circle-bg"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                    <path class="circle"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                      attr.stroke-dasharray="{{
                                               selector_test.selector_test_flows[1]?.percentage + ', 100'

                      }}" />
                  </svg>

                  <span class="percent fc-6">
                    {{
                    selector_test.selector_test_flows[1]?.percentage
                    }}%
                  </span>
                </div>
                <!-- <div class="value">
                  {{
                  selector_test?.selector_test_flows[1]?.transaction_amount !=
                  null
                  ? (selector_test?.selector_test_flows[1]
                  ?.transaction_amount | currency : "BRL")
                  : " R$ 0"
                  }}
                </div> -->

                <!-- <div style="position: relative;">
                  <div class="circle" fxLayoutAlign="center center">A</div>
                  <div class="percent-distrib" fxFlex="auto" fxLayoutAlign="center center">
                    {{selector_test.selector_test_flows[1]?.percentage}}%</div>
                </div> -->
              </div>
            </div>

            <div fxFlex fxLayout="column" fxLayoutAlign="center start">
              <div fxLayout="row" fxLayoutAlign="start center">
                <div class="version mr-2" fxLayout="row" fxLayoutAlign="center center">
                  A
                </div>
                <div class="name">
                  {{ selector_test?.selector_test_flows[1]?.name }}
                </div>

                <div fxLayout="row" fxLayoutAlign="start center">
                  <div class="bullet" [ngClass]="{
                      alert: selector_test.selector_test_flows[1]?.status == 0,
                      success:
                        selector_test.selector_test_flows[1]?.status == 1,
                      paused: selector_test.selector_test_flows[1]?.status == 2,
                      archived: selector_test.selector_test_flows[1]?.status == 3
                    }"></div>
                  <div class="status h-medium" *ngIf="selector_test.selector_test_flows[1]?.status == 0" fxShow>
                    {{ "flows.detail.status.draft" | translate }}
                  </div>
                  <div class="status h-medium" *ngIf="selector_test.selector_test_flows[1]?.status == 1" fxShow>
                    {{ "flows.detail.status.published" | translate }}
                  </div>
                  <div class="status h-medium" *ngIf="selector_test.selector_test_flows[1]?.status == 2" fxShow>
                    {{ "flows.detail.status.paused" | translate }}
                  </div>
                  <div class="status h-medium" *ngIf="selector_test.selector_test_flows[1]?.status == 3" fxShow>
                    {{ "flows.detail.status.archived" | translate }}
                  </div>
                </div>
              </div>
              <div class="description">
                {{ flow_version.flows_descriptor[1]?.description }}
                {{ flow_version.flows_descriptor[1]?.description }}
              </div>
            </div>
          </div>

          <div class="list-itens" fxFlex="none" fxFlex.gt-md="100%" fxLayout="row" fxLayoutGap.md="4px"
            fxLayoutAlign="none">
            <div class="container-itens" fxFlex fxLayout="row">
              <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                fxLayoutGap="5px">
                <div class="text-secondary">
                  {{ "flows.income" | translate }}
                </div>
                <div class="text-primary">
                  {{
                  selector_test.selector_test_flows[1]?.net_amount_percent !=
                  null
                  ? (selector_test.selector_test_flows[1]
                  ?.net_amount_percent | percent : "1.2-2" : "en-us")
                  : " - "
                  }}
                </div>
                <div class="text-secondary">
                  {{
                  selector_test.selector_test_flows[1]?.net_amount != null
                  ? (selector_test.selector_test_flows[1]?.net_amount
                  | currency : "BRL")
                  : " - "
                  }}
                </div>
              </div>

              <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                fxLayoutGap="5px">
                <div class="text-secondary">
                  {{ "flows.approveds" | translate }}
                </div>
                <div fxLayout="row" fxLayoutAlign="start">
                  <div class="text-primary">
                    {{
                    selector_test.selector_test_flows[1]
                    ?.approved_amount_percent != null
                    ? (selector_test.selector_test_flows[1]
                    ?.approved_amount_percent
                    | percent : "1.2-2" : "en-us")
                    : " - "
                    }}
                  </div>
                </div>
                <div class="text-secondary">
                  {{
                  selector_test.selector_test_flows[1]?.approved_amount !=
                  null
                  ? (selector_test.selector_test_flows[1]?.approved_amount
                  | currency : "BRL")
                  : " - "
                  }}
                </div>
              </div>

              <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                fxLayoutGap="5px">
                <div class="text-secondary">{{ "flows.fees" | translate }}</div>
                <div class="text-primary">
                  {{
                  selector_test.selector_test_flows[1]?.fees_amount_percent !=
                  null
                  ? (selector_test.selector_test_flows[1]
                  ?.fees_amount_percent | percent : "1.2-2" : "en-us")
                  : " - "
                  }}
                </div>
                <div class="text-secondary">
                  {{
                  selector_test.selector_test_flows[1]?.fee_amount != null
                  ? (selector_test.selector_test_flows[1]?.fee_amount
                  | currency : "BRL")
                  : " - "
                  }}
                </div>
              </div>

              <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                fxLayoutGap="5px">
                <div class="text-secondary">
                  {{ "flows.fraudCosts" | translate }}
                </div>
                <div fxLayout="row" fxLayoutAlign="start">
                  <div class="text-primary mr-1">
                    {{
                    selector_test.selector_test_flows[1]
                    ?.fraud_costs_percent != null
                    ? (selector_test.selector_test_flows[1]
                    ?.fraud_costs_percent * 100
                    | number : "1.2-2" : "en-us") + "%"
                    : " - "
                    }}
                  </div>
                </div>
                <div class="text-secondary">
                  {{
                  selector_test.selector_test_flows[1]?.fraud_amount != null
                  ? (selector_test.selector_test_flows[1]?.fraud_amount
                  | currency : "BRL")
                  : " - "
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="info-ab">
    <div fxFlex fxLayout="row" fxLayoutAlign="start center">
      <div class="icon" fxFlex="none" fxLayoutAlign="center center">
        <div class="circle science" fxLayoutAlign="center center">
          <mat-icon svgIcon="icon_experiment"></mat-icon>
        </div>
      </div>
      <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
        [ngStyle.gt-sm]="{ 'min-height': '40px' }" [ngStyle.lt-md]="{ 'min-height': '30px' }">
        <div class="allocation">
          {{
          selector_test.selector_test_flows[1]?.percentage + selector_test.selector_test_flows[2]?.percentage
          }}%
          {{ "flows.trafficAllocation" | translate }}
        </div>
        <!-- TODO: Adicionar dado quando vier na api -->
        <!-- <div class="potential">
          <span [ngStyle.lt-sm]="{'display' : 'table', 'table-layout' : 'fixed', 'width' : '100%'}">
            <span
              [ngStyle.lt-sm]="{'display' : 'table-cell', 'white-space' : 'nowrap', 'text-overflow' : 'ellipsis', 'overflow': 'hidden', 'text-align' : 'center'}">
              Estimated monthly potential: R$ 2.88 MM
            </span>
          </span>
        </div> -->
      </div>
    </div>
  </div>

  <mat-card appearance="outlined" class="flow flow-b">
    <mat-card-content>
      <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between" fxLayoutGap="15px">
        <div fxFlex fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" fxLayoutGap.xs="8px"
          fxLayoutAlign="space-between">
          <div fxFlex="39%" fxFlex.md="45%" fxFlex.lt-md="auto" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
            <div class="ab-container" fxFlex="85px" fxFlex.lt-md="75px">
              <div class="distribution" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="6px">
                <div class="graph">
                  <svg viewBox="0 0 36 36" class="circular-chart">
                    <path class="circle-bg"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                    <path class="circle"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                      attr.stroke-dasharray="{{
                        selector_test.selector_test_flows[2]?.percentage+ ', 100'
                      }}" />
                  </svg>
                  <span class="percent fc-6">
                    {{
                    selector_test.selector_test_flows[2]?.percentage
                    }}%
                  </span>
                </div>
                <!-- <div class="value">
                  {{
                  selector_test.selector_test_flows[2]?.transaction_amount !=
                  null
                  ? (selector_test.selector_test_flows[2]
                  ?.transaction_amount | currency : "BRL")
                  : " R$ 0"
                  }}
                </div> -->
              </div>
              <!-- <div fxFlex fxLayout="column" fxLayoutAlign="center center">
                <div style="position: relative;">
                  <div class="circle winner" fxLayoutAlign="center center">B</div>
                  <div class="percent-distrib" fxFlex="auto" fxLayoutAlign="center center">
                    {{selector_test.selector_test_flows[2]?.percentage}}%</div>
                </div>
              </div> -->
            </div>

            <div fxFlex fxLayout="column" fxLayoutAlign="center start">
              <div fxLayout="row" fxLayoutAlign="start center">
                <div class="version mr-2" fxLayout="row" fxLayoutAlign="center center">
                  B
                </div>
                <div class="name version-b">
                  {{ selector_test.selector_test_flows[2]?.name }}
                </div>

                <div fxLayout="row" fxLayoutAlign="start center">
                  <div class="bullet" [ngClass]="{
                      alert: selector_test.selector_test_flows[2]?.status == 0,
                      success:
                        selector_test.selector_test_flows[2]?.status == 1,
                      paused: selector_test.selector_test_flows[2]?.status == 2,
                      archived: selector_test.selector_test_flows[2]?.status == 3
                    }"></div>
                  <div class="status h-medium" *ngIf="selector_test.selector_test_flows[2]?.status == 0" fxShow>
                    {{ "flows.detail.status.draft" | translate }}
                  </div>
                  <div class="status h-medium" *ngIf="selector_test.selector_test_flows[2]?.status == 1" fxShow>
                    {{ "flows.detail.status.published" | translate }}
                  </div>
                  <div class="status h-medium" *ngIf="selector_test.selector_test_flows[2]?.status == 2" fxShow>
                    {{ "flows.detail.status.paused" | translate }}
                  </div>
                  <div class="status h-medium" *ngIf="selector_test.selector_test_flows[2]?.status == 3" fxShow>
                    {{ "flows.detail.status.archived" | translate }}
                  </div>
                </div>
              </div>
              <div class="description">
                {{ flow_version.flows_descriptor[2]?.description }}
              </div>
            </div>
          </div>

          <div class="list-itens" fxFlex="none" fxFlex.gt-md="100%" fxLayout="row" fxLayoutGap.md="4px"
            fxLayoutAlign="none">
            <div class="container-itens" fxFlex fxLayout="row">
              <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                fxLayoutGap="5px">
                <div class="text-secondary">
                  {{ "flows.income" | translate }}
                </div>
                <div class="text-primary">
                  {{
                  selector_test.selector_test_flows[2]?.net_amount_percent !=
                  null
                  ? (selector_test.selector_test_flows[2]
                  ?.net_amount_percent | percent : "1.2-2" : "en-us")
                  : " - "
                  }}
                </div>
                <div class="text-secondary">
                  {{
                  selector_test.selector_test_flows[2]?.net_amount != null
                  ? (selector_test.selector_test_flows[2]?.net_amount
                  | currency : "BRL")
                  : " - "
                  }}
                </div>
              </div>

              <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                fxLayoutGap="5px">
                <div class="text-secondary">
                  {{ "flows.approveds" | translate }}
                </div>
                <div class="text-primary">
                  {{
                  selector_test.selector_test_flows[2]
                  ?.approved_amount_percent != null
                  ? (selector_test.selector_test_flows[2]
                  ?.approved_amount_percent
                  | percent : "1.2-2" : "en-us")
                  : " - "
                  }}
                </div>
                <div class="text-secondary">
                  {{
                  selector_test.selector_test_flows[2]?.approved_amount !=
                  null
                  ? (selector_test.selector_test_flows[2]?.approved_amount
                  | currency : "BRL")
                  : " - "
                  }}
                </div>
              </div>

              <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                fxLayoutGap="5px">
                <div class="text-secondary">{{ "flows.fees" | translate }}</div>
                <div class="text-primary">
                  {{
                  selector_test.selector_test_flows[2]?.fees_amount_percent !=
                  null
                  ? (selector_test.selector_test_flows[2]
                  ?.fees_amount_percent | percent : "1.2-2" : "en-us")
                  : " - "
                  }}
                </div>
                <div class="text-secondary">
                  {{
                  selector_test.selector_test_flows[2]?.fee_amount
                  ? (selector_test.selector_test_flows[2]?.fee_amount
                  | currency : "BRL")
                  : " - "
                  }}
                </div>
              </div>

              <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                fxLayoutGap="5px">
                <div class="text-secondary">
                  {{ "flows.fraudCosts" | translate }}
                </div>
                <div fxLayout="row" fxLayoutAlign="start">
                  <div class="text-primary">
                    {{
                    selector_test.selector_test_flows[2]
                    ?.fraud_costs_percent != null
                    ? (selector_test.selector_test_flows[2]
                    ?.fraud_costs_percent | percent : "1.2-2" : "en-us")
                    : " - "
                    }}
                  </div>
                </div>
                <div class="text-secondary">
                  {{
                  selector_test.selector_test_flows[2]?.fraud_amount
                  ? (selector_test.selector_test_flows[2]?.fraud_amount
                  | currency : "BRL")
                  : " - "
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
